export const product = {
  product: "Προϊόν",
  allProducts: "Προϊόντα & Υπηρεσίες",
  myProducts: "Τα Προϊόντα μου",
  assetManagement: "Τα Περιουσιακά μου",
  addProduct: "Προσθήκη Προϊόντος",
  addEditProduct: "Προσθήκη/Επεξεργασία Προϊόντος",
  saveProduct: "Αποθήκευση Προϊόντος",
  productProperties: "Ιδιότητες Προϊόντος",
  productAttributes: "Χαρακτηριστικά Προϊόντος",
  additionalAttributes: "Πρόσθετες Ιδιότητες",
  additionalAttributesHelp:
    "Τα πεδία προέρχονται από το τρέχον σχήμα πρόσθετων ιδιοτήτων του Back Office.",
  additionalAttributesSaved: "Οι πρόσθετες ιδιότητες αποθηκεύτηκαν.",
  additionalAttributesEmpty:
    "Δεν έχουν αποθηκευτεί πρόσθετες ιδιότητες για αυτό το προϊόν.",
  additionalAttributesNoSchema:
    "Δεν έχει ανέβει ακόμα σχήμα πρόσθετων ιδιοτήτων.",
  additionalAttributesLoadError:
    "Δεν ήταν δυνατή η φόρτωση του σχήματος πρόσθετων ιδιοτήτων.",
  dppRegistryAddError:
    "Δεν ήταν δυνατή η καταχώριση του ψηφιακού διαβατηρίου προϊόντος. Το προϊόν αποθηκεύτηκε.",
  dppRegistryVerifyError:
    "Δεν ήταν δυνατή η επαλήθευση του ψηφιακού διαβατηρίου προϊόντος. Το προϊόν αποθηκεύτηκε.",
  dppRegistryVerifyMismatches:
    "Η επαλήθευση διαβατηρίου εντόπισε παραποιημένα πεδία. Ανοίξτε την καρτέλα DPP για έλεγχο.",
  dppSourceUrlLabel: "Διεύθυνση DPP",
  dppSourceUrlHint:
    "Προαιρετική διεύθυνση GET. Κατά την αποθήκευση, το JSON της αντικαθιστά τον επεξεργαστή παρακάτω. Αφήστε την κενή για να διατηρηθεί το υπάρχον περιεχόμενο. Μια διεύθυνση http φορτώνεται από αυτό το marketplace. Μια διεύθυνση https φορτώνεται από το πρόγραμμα περιήγησης.",
  dppSourceUrlInvalid: "Εισαγάγετε μια διεύθυνση http ή https.",
  dppSourceUrlNetworkError:
    "Δεν ήταν δυνατή η φόρτωση του ψηφιακού διαβατηρίου προϊόντος από αυτή τη διεύθυνση. Ελέγξτε τη διεύθυνση. Για διεύθυνση https, ο διακομιστής πρέπει επίσης να επιτρέπει την ανάγνωση από αυτόν τον ιστότοπο.",
  dppSourceUrlNotJson: "Η διεύθυνση δεν επέστρεψε JSON.",
  dppSourceUrlNotPassport:
    "Το JSON από αυτή τη διεύθυνση δεν είναι ψηφιακό διαβατήριο προϊόντος.",
  additionalAttributesNumberInvalid: "Εισαγάγετε έναν έγκυρο αριθμό.",
  additionalAttributesPatternInvalid:
    "Η τιμή δεν ταιριάζει με το καθορισμένο μοτίβο επικύρωσης.",
  listingTypeProduct: "Προϊόν",
  remanufacturingServiceBadge: "Υπηρεσία Επανακατασκευής",
  productClass: "Κλάση προϊόντος",
  productClassHelp:
    "Επιλέξτε την κλάση τύπου προϊόντος για εμφάνιση των αντίστοιχων πρόσθετων ιδιοτήτων. Αφήστε κενό για επεξεργασία μόνο καθολικών ιδιοτήτων.",
  productClassNotSet: "Μη ορισμένο",
  allProductClasses: "Όλες οι κλάσεις",
  additionalAttributesEmptyForClass:
    "Δεν υπάρχουν πρόσθετες ιδιότητες για την επιλεγμένη κλάση προϊόντος.",
  parameterGroup_energy: "Ενέργεια",
  additionalAttributeGroupSection: "Ομάδα ιδιοτήτων",
  additionalAttributeGroupSelectPlaceholder: "Επιλέξτε ομάδα ιδιοτήτων…",
  productEditStepBasic: "Βασικές πληροφορίες",
  productEditStepClass: "Κλάση προϊόντος",
  productEditStepGroup: "Ομάδα ιδιοτήτων",
  productEditStepLockedHint:
    "Αποθηκεύστε το προηγούμενο βήμα για να συνεχίσετε.",
  confirmUnsavedTitle: "Απόρριψη μη αποθηκευμένων αλλαγών;",
  confirmChangeSelection:
    "Έχετε μη αποθηκευμένες αλλαγές σε αυτό το βήμα. Αν συνεχίσετε, οι αλλαγές θα χαθούν.",
  discardAndContinue: "Απόρριψη και συνέχεια",
  productCategories: "Κατηγορίες Προϊόντων",
  publicName: "Δημόσιο Όνομα",
  tradeName: "Εμπορική Ονομασία",
  vat: "ΦΠΑ",
  url: "URL",
  productName: "Όνομα Προϊόντος",
  name: "Όνομα",
  description: "Περιγραφή",
  cost: "Κόστος",
  numerical: "Αριθμητικό",
  products: "Προϊόντα",
  productDetails: "Λεπτομέρειες Προϊόντος",
  productDetailsNavigation: "Ενότητες σελίδας προϊόντος",
  productPassportTab: "DPP",
  productPassportIntro:
    "Επαληθευμένο ψηφιακό διαβατήριο προϊόντος για αυτό το asset, με δεδομένα ταυτότητας, απόδοσης και βιωσιμότητας.",
  productPassportTabDisabledPendingAcceptance:
    "Διαθέσιμο αφού ο πάροχος αποδεχτεί την έκφραση ενδιαφέροντος.",
  productPassportTabDisabledSignIn:
    "Συνδεθείτε και εκφράστε ενδιαφέρον για πρόσβαση στο DPP μετά την αποδοχή.",
  productPassportTabDisabledLoading:
    "Έλεγχος κατάστασης έκφρασης ενδιαφέροντος…",
  productInterestSentSuccess:
    "Το ενδιαφέρον στάλθηκε. Μπορείτε να παρακολουθείτε τις ενημερώσεις στις Αιτήσεις μου.",
  productInterestAlreadyOpen:
    "Έχετε ήδη ενεργή έκφραση ενδιαφέροντος για αυτό το προϊόν. Παρακολουθήστε την στις Αιτήσεις μου.",
  productInterestDuplicateError:
    "Έχετε ήδη εκφράσει ενδιαφέρον για αυτό το προϊόν.",
  productInterestOpenBadge: "Υποβλήθηκε ενδιαφέρον",
  productInterestOpenBanner:
    "Έχετε ήδη εκφράσει ενδιαφέρον για αυτό το προϊόν. Τρέχουσα κατάσταση: {{status}}.",
  productInterestViewRequests: "Προβολή στις Αιτήσεις μου",
  manufacturer: "Κατασκευαστής",
  yearOfManufacturing: "Έτος Κατασκευής",
  uponRequest: "Κατόπιν Αιτήματος",
  priceUponRequest: "Τιμή Κατόπιν Αιτήματος",
  noProducts: "Δεν υπάρχουν προϊόντα",
  productManagerNewBadge: "Νέο",
  productManagerEmptyHint:
    "Προσθέστε προϊόν ή προσαρμόστε τα φίλτρα για να εμφανιστούν οι καταχωρήσεις σας.",
  productManagerFiltersHint:
    "Περιορίστε τον κατάλογό σας με όνομα, ετικέτες ή εύρος τιμών.",
  productManagerAdvancedFiltersHint:
    "Περιορίστε τα αποτελέσματα με ετικέτες ή εύρος τιμών.",
  priceRangeAny: "Οποιαδήποτε τιμή",
  filterByName: "Φιλτράρισμα με όνομα",
  filterByAuthor: "Φιλτράρισμα με συγγραφέα",
  sortBy: "Ταξινόμηση κατά",
  sortOrder: "Σειρά ταξινόμησης",
  sortAscending: "Αύξουσα",
  sortDescending: "Φθίνουσα",
  productsBrowseEmptyHint:
    "Δοκιμάστε να προσαρμόσετε την αναζήτηση ή τα φίλτρα για να βρείτε προϊόντα προς πώληση.",
  minPrice: "Ελάχιστη τιμή",
  maxPrice: "Μέγιστη τιμή",
  postedBy: "Αναρτήθηκε Από",
  createdAt: "Δημιουργήθηκε Στις",
  selectSubCategory: "Επιλέξτε Υποκατηγορία",
  selectExtraCategory: "Επιλέξτε Επιπλέον Κατηγορία",
  price: "Τιμή",
  isUsed: "Χρησιμοποιημένο",
  condition: "Κατάσταση",
  contactPerson: "Πρόσωπο Επικοινωνίας",
  person: "Πρόσωπο",
  contactEmail: "Email Επικοινωνίας",
  email: "Email",
  contactPhoneNumber: "Τηλέφωνο Επικοινωνίας",
  phoneNumber: "Αριθμός Τηλεφώνου",
  paymentInfo: "Πληροφορίες Πληρωμής",
  updateProduct: "Ενημέρωση Προϊόντος",
  updatedAt: "Ενημερώθηκε Στις",
  inventory: "Απόθεμα",
  quantity: "Ποσότητα",
  addInventory: "Προσθήκη Αποθέματος",
  notes: "Σημειώσεις",
  myProduct: "Το Προϊόν μου",
  addToCart: "Προσθήκη στο Καλάθι",
  createdBy: "Από",
  me: "Εγώ",
  filters: "Φίλτρα",
  filter: "Φίλτρο",
  clear: "Επαναφορά",
  details: "Λεπτομέρειες",
  withImages: "Με Εικόνες",
  author: "Συγγραφέας",
  syncWithExternalMarketplaces: "Συγχρονισμός με Εξωτερικές Αγορές",
  somethingWentWrong: "Κάτι πήγε στραβά",
  pleaseContactTheAdministrator: "Παρακαλώ επικοινωνήστε με τον διαχειριστή",
  perPage: "ανά σελίδα",
  propertyValue: "Τιμή Ιδιότητας",
  fillThePropertyFirst: "Συμπληρώστε πρώτα την ιδιότητα",
  onlyDeletesEmptyProperty: "Διαγράφει μόνο κενή ιδιότητα",
  basicInformation: "Βασικές Πληροφορίες",
  generalOrderInfo: "Γενικές Πληροφορίες Παραγγελίας",
  linePerformance: "Γραμμή παραγωγής & Επίδοση",
  all: "Όλα",
  forSale: "Προς Πώληση",
  currentOwner: "Τρέχων Κάτοχος",
  serialNumber: "Σειριακός Αριθμός",
  installationRequirements: "Απαιτήσεις Εγκατάστασης",
  processingInfo: "Πληροφορίες Επεξεργασίας",
  notForSale: "Όχι προς Πώληση",
  spareParts: "Ανταλλακτικά",
  incumbent: "Εν ενεργεία",
  productCapabilities: "Δυνατότητες Προϊόντος",
  equipmentCapabilities: "Δυνατότητες Εξοπλισμού",
  deleteProduct: "Διαγραφή Προϊόντος",
  deleteProductWarning:
    "Είστε σίγουρος/η ότι θέλετε να διαγράψετε αυτό το προϊόν;",
  anErrorOccurred: "Προέκυψε ένα σφάλμα",
  errorFetchingProducts: "Σφάλμα κατά την ανάκτηση των προϊόντων",
  lastRemanufacturer: "Τελευταίος Επανακατασκευαστής",
  yearOfLastRemanufacturing: "Έτος τελευταίας επανακατασκευής",
  tags: "Ετικέτες",
  tag: "Ετικέτα",
  deleteThisProduct: "Διαγράψτε αυτό το προϊόν",
  requiredWorkerSkills: "Απαιτούμενες Δεξιότητες Εργαζομένων",
  existingWorkerSkills: "Υπάρχουσες Δεξιότητες Εργαζομένων",
  workerSkills: "Δεξιότητες Εργαζομένων",
  factoryOwnerRequirements: "Απαιτήσεις Ιδιοκτήτη Εργοστασίου",
  environmentalProperties: "Περιβαλλοντικές Ιδιότητες",
  connectionCapabilities: "Δυνατότητες Σύνδεσης",
  byAuction: "Με Δημοπρασία",
  visitWebsite: "Επισκεφθείτε την Ιστοσελίδα",
  manufacturedYear: "Έτος Κατασκευής",
  productId: "Αναγνωριστικό προϊόντος",
  productIdPending: "Ανατίθεται αυτόματα μετά την αποθήκευση",
  ownerKeycloak: "Ιδιοκτήτης (Keycloak user ID)",
  owner: "Ιδιοκτήτης",
  ownerFieldTooltip: "Δηλώστε τον τρέχοντα ιδιοκτήτη",
  videoAssets: "Βίντεο",
  documentAssets: "Έγγραφα",
  basePrice: "Βασική τιμή",
  promotionalPrice: "Προωθητική τιμή",
  taxRate: "Συντελεστής φόρου",
  currency: "Νόμισμα",
  availableQuantity: "Διαθέσιμη ποσότητα",
  clickOrDropMediaFiles:
    "Κάντε κλικ ή σύρετε αρχεία εδώ για να ανεβάσετε βίντεο ή έγγραφα.",
  clickOrDropImageFiles:
    "Κάντε κλικ ή σύρετε αρχεία εδώ για να ανεβάσετε εικόνες.",
  clickOrDropVideoFiles:
    "Κάντε κλικ ή σύρετε αρχεία εδώ για να ανεβάσετε βίντεο.",
  clickOrDropDocumentFiles:
    "Κάντε κλικ ή σύρετε αρχεία εδώ για να ανεβάσετε έγγραφα.",
  dataset: "Σύνολο Δεδομένων",
  datasets: "Σύνολα Δεδομένων",
  datasetManagement: "Διαχείριση Datasets",
  allDatasets: "Όλα τα Datasets",
  myDatasets: "Τα Datasets μου",
  noDatasets: "Δεν υπάρχουν Datasets",
  datasetName: "Όνομα Dataset",
  dataType: "Τύπος Δεδομένων",
  industrySector: "Κλάδος Βιομηχανίας",
  datasetDetails: "Λεπτομέρειες Dataset",
  format: "Τύπος",
  dataCollectionMethod: "Μέθοδος Συλλογής Δεδομένων",
  associatedResearch: "Σχετική Έρευνα",
  systemicInnovation: "Συστηματική Καινοτομία",
  systemicInnovations: "Συστηματικές Καινοτομίες",
  mySystemicInnovations: "Οι Συστηματικές Καινοτομίες μου",
  associatedSystemicInnovations: "Οι Σχετιζόμενες Συστηματικές Καινοτομίες μου",
  allSystemicInnovations: "Όλες οι Συστηματικές Καινοτομίες",
  addSystemicInnovation: "Προσθήκη Συστηματικής Καινοτομίας",
  implementationLevel: "Επίπεδο Υλοποίησης",
  licenseType: "Τύπος Άδειας",
  benefits: "Οφέλη",
  addEditDataset: "Προσθήκη/Επεξεργασία Dataset",
  addEditSystemicInnovation: "Προσθήκη/Επεξεργασία Συστηματικής Καινοτομίας",
  systemicInnovationDetails: "Λεπτομέρειες Συστηματικής Καινοτομίας",
  regulatoryCompliance: "Κανονιστική Συμμόρφωση",
  competitionAnalysis: "Ανάλυση Ανταγωνισμού",
  valueProposition: "Πρόταση Αξίας",
  problemStatement: "Δήλωση Προβλήματος",
  deleteDataset: "Διαγραφή Dataset",
  contactPhone: "Τηλέφωνο Επικοινωνίας",
  shortDescription: "Σύντομη Περιγραφή",
  fullDescription: "Αναλυτική Περιγραφή",
  dataProvider: "Πάροχος Δεδομένων",
  size: "Μέγεθος",
  updateFrequency: "Συχνότητα Ενημέρωσης",
  accessLevel: "Επίπεδο Πρόσβασης",
  geographicalScope: "Γεωγραφική Εμβέλεια",
  timePeriodCovered: "Καλυπτόμενη Χρονική Περίοδος",
  variablesFeatures: "Μεταβλητές & Χαρακτηριστικά",
  compliancePlusStandards: "Συμμόρφωση & Πρότυπα",
  associatedResearchPublications: "Συναφής Έρευνα & Δημοσιεύσεις",
  pricingInfo: "Πληροφορίες Τιμολόγησης",
  contactPersonOrganization: "Υπεύθυνος Επικοινωνίας / Οργανισμός",
  lastUpdated: "Τελευταία Ενημέρωση",
  insertedByUser: "Καταχωρήθηκε από Χρήστη",
  apiUrl: "Σύνδεσμος API",
  leadingOrganizations: "Ηγετικοί Οργανισμοί",
  technologyStack: "Τεχνολογική Υποδομή",
  objectives: "Στόχοι",
  benefitsAndExpectedOutcomes: "Οφέλη & Αναμενόμενα Αποτελέσματα",
  measurableImpact: "Μετρήσιμη Επίδραση",
  pilotLocations: "Πιλοτικές Τοποθεσίες",
  caseStudies: "Μελέτες Περίπτωσης",
  regulatoryComplianceAndEthicsConsiderations:
    "Κανονιστική Συμμόρφωση & Ηθικά Ζητήματα",
  publicationsReportsAndMedia: "Δημοσιεύσεις, Αναφορές & Μέσα",
  relatedDatasets: "Σχετικά Σύνολα Δεδομένων",
  pricingModel: "Μοντέλο Τιμολόγησης",
  noSystemicInnovations: " Δεν υπάρχουν Συστηματικές Καινοτομίες",
  addDataset: "Προσθήκη Dataset",
  informationAboutBusinessModels: "Πληροφορίες για Επιχειρηματικά Μοντέλα",
  businessModels: "Επιχειρηματικά Μοντέλα",
  processingAndInstallation: "Επεξεργασία & Εγκατάσταση",
  basePlateWidth: "Πλάτος Βάσης",
  basePlateLength: "Μήκος Βάσης",
  basePlateMountingInfo: "Πληροφορίες Τοποθέτησης Βάσης",
  mountingPosition: "Θέση Τοποθέτησης",
  foundationRequirements: "Απαιτήσεις Θεμελίωσης",
  ambientTempMin: "Ελάχ. Θερμοκρασία Περιβάλλοντος",
  ambientTempMax: "Μέγ. Θερμοκρασία Περιβάλλοντος",
  pressureAirSupply: "Παροχή Πεπιεσμένου Αέρα",
  pressureAirSpecs: "Προδιαγραφές Πεπιεσμένου Αέρα",
  exhaustSystem: "Σύστημα Εξαγωγής",
  exhaustSystemSpecs: "Προδιαγραφές Συστήματος Εξαγωγής",
  powerConnection: "Σύνδεση Ρεύματος",
  powerConnectionSpecs: "Προδιαγραφές Σύνδεσης Ρεύματος",
  waterSupply: "Παροχή Νερού",
  waterSupplySpecs: "Προδιαγραφές Παροχής Νερού",
  gasSupply: "Παροχή Αερίου",
  gasSupplySpecs: "Προδιαγραφές Παροχής Αερίου",
  energyConsumption: "Κατανάλωση Ενέργειας",
};
